/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getBooleanDecoder,
  getBooleanEncoder,
  getStructDecoder,
  getStructEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type NetworkSecurityPolicies = {
  firewallRequired: boolean;
  intrusionDetection: boolean;
  trafficMonitoring: boolean;
};

export type NetworkSecurityPoliciesArgs = NetworkSecurityPolicies;

export function getNetworkSecurityPoliciesEncoder(): FixedSizeEncoder<NetworkSecurityPoliciesArgs> {
  return getStructEncoder([
    ["firewallRequired", getBooleanEncoder()],
    ["intrusionDetection", getBooleanEncoder()],
    ["trafficMonitoring", getBooleanEncoder()],
  ]);
}

export function getNetworkSecurityPoliciesDecoder(): FixedSizeDecoder<NetworkSecurityPolicies> {
  return getStructDecoder([
    ["firewallRequired", getBooleanDecoder()],
    ["intrusionDetection", getBooleanDecoder()],
    ["trafficMonitoring", getBooleanDecoder()],
  ]);
}

export function getNetworkSecurityPoliciesCodec(): FixedSizeCodec<
  NetworkSecurityPoliciesArgs,
  NetworkSecurityPolicies
> {
  return combineCodec(
    getNetworkSecurityPoliciesEncoder(),
    getNetworkSecurityPoliciesDecoder(),
  );
}
